import { render, staticRenderFns } from "./avtimeMarket.vue?vue&type=template&id=7d37355c&scoped=true&"
import script from "./avtimeMarket.vue?vue&type=script&lang=js&"
export * from "./avtimeMarket.vue?vue&type=script&lang=js&"
import style0 from "./avtimeMarket.vue?vue&type=style&index=0&id=7d37355c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37355c",
  null
  
)

export default component.exports